/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 9.06.24
 *
 */
const iconTransitionMap = {
	// "icon-edit": { x: "1px", y: "-2px" },
	// "icon-pencil": { x: "1px", y: "0px" },
	"icon-user-add": { x: "1px", y: "-1px" },
	"icon-calendar-empty": { x: "0px", y: "-0.5px" },
	// "icon-doc-text": { x: "1px", y: "-0.5px" },
	"icon-cancel": { x: "0px", y: "-1px" },
	// "icon-cancel-1": { x: "1.5px", y: "0px" },
	// "icon-trash": { x: "1.5px", y: "0px" },
	// "icon-share": { x: "0.5px", y: "0px" },
	// "icon-ellipsis-vert": { x: "1.5px", y: "1px" },


	"ic-move-to.svg": { x: "-0.5px", y: "-1px" },

}
export {
	iconTransitionMap
}
